import { ReactElement, useState } from 'react';

import { MobilePreviewBarLayout } from '~/components/organisms/previewBar/mobile/MobilePreviewBarLayout';
import { QRPreviewBar } from '~/components/organisms/previewBar/mobile/QRPreviewBar';
import MobileFooterStepper from '~/components/organisms/stepper/MobileFooterStepper';
import { StaticQrCodeData } from '~/types/qrCode';

import { StyledContainer, StyledContent } from './styled';

type MobileStaticContentComponentProps = {
  isNextProcessing?: boolean;
  qrCode?: StaticQrCodeData; // Replace with a specific type if available
  activeStep?: number;
  handleStep?: (step: number) => void;
  mockup?: ReactElement;
  form?: ReactElement;
  isMobileQrButtonHidden?: boolean;
};
export const MobileStaticContentComponent = ({
  handleStep,
  activeStep,
  isNextProcessing,
  qrCode,
  mockup,
  form,
  isMobileQrButtonHidden = false,
}: MobileStaticContentComponentProps) => {
  const [isPreviewBarOpen, setIsPreviewBarOpen] = useState(false);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);

  return (
    <StyledContainer>
      <StyledContent>
        {form}
        <MobilePreviewBarLayout isOpen={isPreviewBarOpen} onClose={() => setIsPreviewBarOpen(false)}>
          {mockup}
        </MobilePreviewBarLayout>
        <MobileFooterStepper
          handleBack={() => handleStep(activeStep - 1)}
          handleNext={() => handleStep(activeStep + 1)}
          isNextProcessing={isNextProcessing}
          isQrButtonHidden={isMobileQrButtonHidden}
          activeStep={activeStep}
          showQRModal={() => setIsQrModalOpen(true)}
          showPreviewModal={() => setIsPreviewBarOpen(true)}
        />
        <QRPreviewBar onClose={() => setIsQrModalOpen(false)} isOpen={isQrModalOpen} qrImageUrl={qrCode?.qrImage} />
      </StyledContent>
    </StyledContainer>
  );
};
